import React, { useEffect, useRef, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { notifyError, notifyInfo, notifySuccess } from "../../helper";
import client from "../../api";
import { format } from "date-fns";
import Trophy from '../../assets/images/trophy.svg';
import { exportCampaignRecipientsReport } from "../../helper";
import EditCampaignNameModelWindow from "./models/EditCampaignNameModelWindow";
import CopyCampaignModelWindow from "./models/CopyCampaignModelWindow";
import DeleteCampaignModelWindow from "./models/DeleteCampaignModelWindow";
import RescheduleCampaignModelWindow from "./models/RescheduleCampaignModelWindow";
import BlockLoader from "../BlockLoader";
const CampaignHeader = (props) => {
    const api = client()
    const {campaignID} = useParams('');
    const [overview, setOverview] = useState();
    const [overviewMenu,setOverviewMenu] = useState(false);
    const [displayEditNameModelWindow,setDisplayEditNameModelWindow] = useState(false);
    const [displayCopyModelWindow,setDisplayCopyModelWindow] = useState(false);
    const [exportLoader, setExportLoader] = useState(false);
    const [refreshOverview, setRefreshOverview] = useState(false);
    const [startNowLoader, setStartNowLoader] = useState(false);
    const [toggleRescheduleModelWindow,setToggleRescheduleModelWindow] = useState(false);
    const [toogleDeleteModelWindow,setToogleDeleteModelWindow] = useState(false);
    const menuRef = useRef(null);
    
    const updateCampaignStatus = async (type) => {
        try{
            const response = await api.post('/v1/campaign/status/update',{
                campaigns_id:[campaignID],
                status: type,
            });
            if(response.status === 200 || response.status === 201){
                notifySuccess('Campaign Status updated successfully');
                window.location.reload();
            }
        } catch(error){
            console.log('error.message',error);
            if(error.status === 400) notifyError('Bad Request, Not able to change the status of campaign. Please try again');
        }
    }
    const showCampaignStatus = () => {
        let campaignStatus = '';
        if(overview?.status === 'paused'){
            campaignStatus = ' Campaign is paused';            
        } else {
            let count = 0;
            overview?.steps.forEach((step)=>{
                if(step.status === 'pause'){
                    count = count + 1;
                }
            });

            if(count && overview?.assigned_to_user?.status !== 'active'){ 
                campaignStatus = ` ${count} message paused, ${overview?.assigned_to_user?.status === 'deleted' ? ' Mail account is not assigned':' Assigned mail account is not working.'}`; 
            } 

            if(!count && overview?.assigned_to_user?.status !== 'active') { 
                campaignStatus = `${overview?.assigned_to_user?.status === 'deleted' ? ' Mail account is not assigned': ' Assigned mail account is not working.'}`;
            }

            if(!count && overview?.assigned_to_user?.status === 'active') { 
                campaignStatus = ' Nothing is paused';
            }
        }
        return campaignStatus;
    }

    const toggleOverviewMenu = () => {
        setOverviewMenu(!overviewMenu);
    }

    const handleEditNameModelWindow = () => {
        setDisplayEditNameModelWindow(!displayEditNameModelWindow);
    }

    const handleCopyModelWindow = () => {
        setDisplayCopyModelWindow(!displayCopyModelWindow);
    }


    const handleCampaignRecipientsDownload = async () => {
        try{
            setExportLoader(true);
            const response = await api.post('/v1/campaign/export',{campaign_id:campaignID});
            if(response.status === 200 || response.status === 201){
                setExportLoader(false);
                if(Object.keys(response.data.eventsCountPerContact).length){
                    exportCampaignRecipientsReport(response.data.eventsCountPerContact,"campaings_recipients");
                } else {
                    notifyInfo('Data is not available');
                }
                
            }
        } catch(error){
            setExportLoader(false);
            console.log("error.message",error);
            if(error.status === 400){
                notifyError('Bad request. Unable to fetch Campaign Recipients Info. Please try again');
             }
        } finally {
            setExportLoader(false);
        }
    }

    const handleStartNow = async() => {
        try{
            setStartNowLoader(true);
            const payload = {
                campaigns_id:[campaignID],
                status: 'started',
            }
            const response = await api.post('/v1/campaign/status/update',payload);
            if(response.status === 200 || response.status === 201){
                notifySuccess("Campaign Status is updated successfully");
                setStartNowLoader(false);
                setRefreshOverview(!refreshOverview);
                toggleOverviewMenu(false); //close the menu
            }
        } catch (error) {
            setStartNowLoader(false);
            console.log('error.message',error);
            if(error.status === 400){
                notifyError('Bad Request. Unable to change status of the campaign. Please try again.');
            }
        } finally{
            setStartNowLoader(false);
        }
    }

    useEffect(()=>{
        const getOverview = async () => {
            try{
                const response = await api.post('/v1/campaign/preview',{ campaign_id:campaignID });
                if(response.status === 200 ||response.status === 201 ){
                    setOverview(response.data.campaignPreview);
                }
            } catch(error){
                console.log('error.message',error);
                if(error.status === 400) notifyError('Bad Request. Not able to fetch Campaign Overview');
            }
        }
        getOverview();
    },[refreshOverview]);
        
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setOverviewMenu(false);
            } 
        };
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);
    
    return(<>
        <div className="overview-header">
            { overview === undefined ? <><BlockLoader height="120px"/></> : <>
            <div className="overview-header-top">
                <div className="left-block">
                <div className="campgain-start">
                    { overview?.status === 'complete' ? <div className="trophy"><Trophy/></div> :''}
                    {overview?.status === 'started' ? <button onClick={()=>{
                            updateCampaignStatus('paused');
                        }}><i className="bx bx-pause"></i></button>:''}
                    {overview?.status === 'paused' ? <button onClick={()=>{
                            updateCampaignStatus('started');
                        }}><i className="bx bx-play"></i></button>:''}

                    {overview?.status === 'scheduled' ? <button onClick={()=>{
                            //updateCampaignStatus('started');
                        }}><i className='bx bx-time-five'></i></button>:''}
                        
                    </div>
                
                </div>
                <div className="right-block">
                    <div className="overview-menu-wrap">
                        <h1>{overview?.name}</h1> 
                        <div className="dot-menu-box" ref={menuRef}>
                            <button className="dot-menu-btn" onClick={()=>toggleOverviewMenu()}>
                                <i className='bx bx-dots-vertical-rounded'></i>
                            </button>
                            <ul className={overviewMenu ? `overview-menu open`:`overview-menu`}>
                                <li onClick={()=>handleEditNameModelWindow()}><span>Edit Title</span></li>
                                <li onClick={()=>{window.location.reload()}}><span>Refresh</span></li>
                                <li onClick={()=>handleCopyModelWindow()}><span>Duplicate</span></li>
                                <li>
                                    <button
                                        type="button"
                                        className={exportLoader ? "export-btn button--loading":"export-btn"} 
                                        disabled={exportLoader}
                                        onClick={()=>handleCampaignRecipientsDownload()}>
                                        <span className="button--text">Export</span>
                                    </button>
                                </li>
                                {overview?.status === 'scheduled' ? <> 
                                    <li>
                                        <button
                                            type="button"
                                            className={startNowLoader ? "export-btn button--loading":"export-btn"} 
                                            disabled={startNowLoader}
                                            onClick={()=>handleStartNow()}>
                                            <span className="button--text">Start Now</span>
                                        </button>
                                    </li> 
                                    <li onClick={()=>setToggleRescheduleModelWindow(!toggleRescheduleModelWindow)}><span>Reschedule</span></li>
                                </>:''}
                                <li onClick={()=>setToogleDeleteModelWindow(!toogleDeleteModelWindow)}><span>Delete</span></li>
                            </ul>
                        </div>
                    </div>
                    <p>{overview?.assigned_to_user?.status === 'deleted' ? `Not assigned` : `Assigned to ${overview?.assigned_to_user?.email}`}, created {overview?.created_at !== undefined && format(overview?.created_at, 'MMM d, yyyy')} </p>
                    <p>{overview?.initial_step_total_recipients} recipients. 
                        <span>{showCampaignStatus()}</span></p>
                    {(overview?.setting?.start_time && (overview?.status === 'scheduled' && overview?.setting?.start_time > 0) ? <p>Scheduled to run at {format(overview?.setting?.start_time, "MMM d, yyyy hh:mm a")}</p>:'')}
                </div>
            </div>
            <div className="overview-header-bottom">
                <ul>
                    <li>
                        <Link to={`/campaign/${campaignID}/overview`} className={props.page === 'overview' ? "selected" :""}>Overview</Link>
                    </li>
                    <li>
                        <Link to={`/campaign/${campaignID}/sequence`} className={props.page === 'sequence' ? "selected" :""}>Sequence</Link>
                    </li>
                    <li>
                        <Link to={`/campaign/${campaignID}/recipients`} className={props.page === 'recipients' ? "selected" :""}>Recipients</Link>
                    </li>
                    <li>
                        <Link to={`/campaign/${campaignID}/settings`} className={props.page === 'settings' ? "selected" :""}>Settings</Link>
                    </li>
                </ul>
            </div> 
            </>}
        </div>

        {displayEditNameModelWindow && <EditCampaignNameModelWindow
            name = { overview?.name }
            setDisplayEditNameModelWindow = { setDisplayEditNameModelWindow }
            displayEditNameModelWindow = { displayEditNameModelWindow }
        />}

        {displayCopyModelWindow && <CopyCampaignModelWindow
            setDisplayCopyModelWindow = { setDisplayCopyModelWindow }
            displayCopyModelWindow = { displayCopyModelWindow }
        />}

        {toggleRescheduleModelWindow && <RescheduleCampaignModelWindow 
            toggleRescheduleModelWindow = { toggleRescheduleModelWindow }
            setToggleRescheduleModelWindow = { setToggleRescheduleModelWindow }
            start_time = {overview?.setting?.start_time_local !== null ? new Date(overview?.setting?.start_time_local) : new Date()}
            start_timezone = {overview?.setting?.start_time_zone !== '' ? overview?.setting?.start_time_zone : ''}
            refreshOverview = { refreshOverview } 
            setRefreshOverview = { setRefreshOverview }
        />}

        {toogleDeleteModelWindow && <DeleteCampaignModelWindow
            setToogleDeleteModelWindow = { setToogleDeleteModelWindow }
            toogleDeleteModelWindow = { toogleDeleteModelWindow }
        />}

    </>);
}

export default CampaignHeader;